import type { ScreenContext } from './types.ts';
import { createContinueButton } from '@/components/continue-button.ts';
import { createMoodSlider } from '@/components/mood-slider.ts';

const activities = [
  'working',
  'relaxing',
  'studying',
  'commuting',
  'emotional_processing',
  'other',
];

export function renderContext(container: HTMLElement, { dispatch }: ScreenContext) {
  const startedAt = performance.now();
  container.innerHTML = `
    <div class="card space-y-6">
      <div>
        <p class="text-sm uppercase tracking-wide text-gray-500">Step 1</p>
        <h2 class="text-2xl font-semibold text-gray-900">What are you doing right now?</h2>
        <p class="text-gray-700 mt-1">We use this to tailor insights.</p>
      </div>
      <div id="activity-group" class="grid grid-cols-2 gap-3"></div>
      <div id="energy-slot"></div>
      <div id="stress-slot"></div>
      <div id="action-slot"></div>
    </div>
  `;

  const activityGroup = container.querySelector('#activity-group') as HTMLElement;
  activities.forEach((key) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.dataset.value = key;
    btn.className =
      'border rounded-lg px-4 py-3 text-sm text-gray-800 hover:border-blue-500 focus:ring-2 focus:ring-blue-500';
    btn.textContent = formatActivityLabel(key);
    activityGroup.appendChild(btn);
  });

  let selectedActivity = activities[0];
  activityGroup.firstElementChild?.classList.add('border-blue-500', 'bg-blue-50');

  activityGroup.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    const value = target.dataset.value;
    if (!value) return;
    selectedActivity = value;
    activityGroup.querySelectorAll('button').forEach((b) => {
      b.classList.remove('border-blue-500', 'bg-blue-50');
    });
    target.classList.add('border-blue-500', 'bg-blue-50');
  });

  const energySlider = createMoodSlider('energy', 'Energy level', 5,true);
  container.querySelector('#energy-slot')?.appendChild(energySlider.root);

  const actionSlot = container.querySelector('#action-slot') as HTMLElement;
  const btn = createContinueButton('Continue');
  actionSlot.appendChild(btn);

  btn.addEventListener('click', () => {
    const durationMs = Math.round(performance.now() - startedAt);
    dispatch({
      type: 'SET_CONTEXT',
      payload: {
        activity: selectedActivity,
        energy: energySlider.getValue(),
        stress: 0,
        durationMs,
      },
    });
    dispatch({ type: 'NEXT_PHASE' });
  });
}

function formatActivityLabel(value: string): string {
  return value
    .replace('_', ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
